export interface Memberships {
  aveloPlus: boolean;
  discountDen: boolean;
}

export const NO_MEMBERSHIPS: Memberships = { aveloPlus: false, discountDen: false };

/** Coerce an API body to flags; anything missing or malformed is "not a member". */
export function parseMemberships(body: unknown): Memberships {
  const b = (body ?? {}) as Record<string, unknown>;
  return { aveloPlus: b.aveloPlus === true, discountDen: b.discountDen === true };
}

export const MEMBERSHIP_OPTIONS: Array<{ key: keyof Memberships; label: string; blurb: string }> = [
  { key: 'aveloPlus', label: 'Avelo PLUS', blurb: 'We show your member fare and stop counting the membership against the saving.' },
  { key: 'discountDen', label: 'Frontier Discount Den', blurb: 'We show Den fares and skip the Den upsell.' },
];

/** The next state after flipping one switch (immutable). */
export function toggled(m: Memberships, key: keyof Memberships): Memberships {
  return { ...m, [key]: !m[key] };
}
